import { useState } from "react";
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import { updateContactVisible, updateGooglemeetVisible, updateDimmed } from "../../features/forms/formsSlice";
import { Wrapper, TopBlock, BottomBlock, TextBlock, Heading, BodyText, LinkText, OpenForm, AboutUs, Instagram, X, Facebook, TeachLearn } from "./FooterStyle"
import ContactForm from "./01_contactform/ContactForm";
import GoogleMeetForm from "./02_googlemeet/GoogleMeet.js";
import { footer } from "../../i18n/10_footer.js";

const Footer = () => {
    const lang = useSelector(state => state.lang.lang)
    const t = footer[lang]

    const [footerDimmed, setFooterDimmed] = useState(false)

    const [workinprogress, setWorkinprogress] = useState(false)

    const contactVisible = useSelector(state => state.forms.contactVisible)
    const googlemeetVisible = useSelector(state => state.forms.googlemeetVisible)

    const dispatch = useDispatch()

    const makeContactVisible = (e) => {
        e.preventDefault()
        dispatch(updateContactVisible(true))
        dispatch(updateDimmed(true))
    }

    const makeGooglemeetVisible = (e) => {
        e.preventDefault()
        dispatch(updateGooglemeetVisible(true))
        dispatch(updateDimmed(true))
    }

    const showWIP = () => {
        setWorkinprogress(!workinprogress)
    }

    const renderItem = (item, idx) => {
        switch (item.type) {
            case "text":
                return <BodyText key={idx}>{item.text}</BodyText>;

            case "link":
                return (
                    <LinkText key={idx} href={item.href}>
                        {item.text}
                    </LinkText>
                );

            case "extLink":
                return (
                    <LinkText
                        key={idx}
                        href={item.href}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {item.text}
                    </LinkText>
                );

            case "route":
                return (
                    <AboutUs key={idx} to={item.to}>
                        {item.text}
                    </AboutUs>
                );

            case "action":
                if (item.text === "Send a Message" || item.text === "Написати повідомлення") {
                    return (
                        <OpenForm key={idx} onClick={makeContactVisible}>
                            {item.text}
                        </OpenForm>
                    )
                }
                if (item.text === "Google Meet") {
                    return (
                        <OpenForm
                        key={idx}
                        onClick={makeGooglemeetVisible}>
                            {item.text}
                        </OpenForm>
                    )
                }

            case "social":
                if (item.name === "instagram") return <Instagram key={idx} onClick={showWIP} />;
                if (item.name === "x") return <X key={idx} onClick={showWIP} />;
                if (item.name === "facebook") return <Facebook key={idx} onClick={showWIP} />;
                return null;

            case "wipText":
                return (
                    <BodyText key={idx}>
                        <i>{workinprogress && item.text}</i>
                    </BodyText>
                );

            default:
                return null;
        }
    };

    return (
        <Wrapper>

            <ContactForm
                contactVisible={contactVisible}
                footerDimmed={footerDimmed}
            />
            <GoogleMeetForm
                googlemeetVisible={googlemeetVisible}
                footerDimmed={footerDimmed}
            />

            <TopBlock>
                {t.columns.map((col, i) => (
                    <TextBlock key={i}>
                        <Heading>{col.heading}</Heading>
                        {col.items.map(renderItem)}
                    </TextBlock>
                ))}
            </TopBlock>
            <BottomBlock>
                <TeachLearn to="/">TeachLearn.co.uk</TeachLearn>
            </BottomBlock>
        </Wrapper>
    )
}

export default Footer